module.exports = __webpack_public_path__ + "static/key-turok2-24377a144c09568ab3c1f6da6d47391d.webp";